module.exports = __webpack_public_path__ + "img/pathology-overhang.470a10a0.png";